"use client";

import { useEffect, useRef, useState } from "react";

// Poster image paints first (it is the LCP element); the video only starts downloading after the
// page has loaded, picks a phone or desktop encode, and fades in once it is actually playing.
// Skipped entirely for reduced-motion and data-saver visitors.
export default function HeroVideo({ poster, posterMobile, desktop, mobile }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const saveData = navigator.connection?.saveData;
    if (reduce || saveData) return;
    const start = () => {
      v.src = window.matchMedia("(max-width: 760px)").matches ? mobile : desktop;
      v.play().catch(() => {});
    };
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });
    return () => window.removeEventListener("load", start);
  }, [desktop, mobile]);

  return (
    <>
      {/* Posters are the videos' first frames at the same size, so the video fading in never
          counts as a new, larger paint (keeps LCP on the poster). */}
      <picture>
        {posterMobile && <source media="(max-width: 760px)" srcSet={posterMobile} />}
        <img src={poster} alt="Inside Lulu Wild, Chinese restaurant and cocktail bar at Brindleyplace, Birmingham" fetchPriority="high" className="hero-poster" />
      </picture>
      <video
        ref={ref}
        muted
        loop
        playsInline
        preload="none"
        aria-hidden="true"
        onPlaying={() => setPlaying(true)}
        className={`hero-video ${playing ? "is-playing" : ""}`}
      />
    </>
  );
}
